import {connect} from 'react-redux';

import _ from 'topmeteo/utils/i18n';

import {changeColored} from '../../actionCreators';

import CheckboxGroup from './CheckboxGroup';

const Label = _('Colored');

const ColoredCheckbox = ({colored, onChange}) => (
    <CheckboxGroup id="osm-settings-colored" label={Label} checked={colored} onChange={onChange} />
);

const mapStateToProps = ({OSMColored}) => ({colored: OSMColored});

const mapDispatchToProps = dispatch => ({
    onChange: ({target}) => dispatch(changeColored(target.checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ColoredCheckbox);
